import React, { useState, useCallback } from "react";
import axios from "../api";
import { getFirebaseIdentityHeaders } from "../../../config/firebaseUser";
import { useHistory } from "react-router-dom";
import { pasarSumasTurnosACierreDiaApi } from "../services/pasarSumasCierreDia";
import AjusteMensualesConsultaTurnoTable from "./AjusteMensualesConsultaTurnoTable";
import AjusteMensualesConsultaDiaTable from "./AjusteMensualesConsultaDiaTable";
import "../cierreTurno/CierreTurno.css";
import "./AjusteMensuales.css";

function mensajeErrorApi(error) {
  const d = error.response?.data;
  if (!d) return error.message || "Error desconocido";
  const m = d.message;
  if (Array.isArray(m)) return m.join(" ");
  return m || d.error || error.message || "Error desconocido";
}

const AjusteMensualesContainer = () => {
  const history = useHistory();
  const [cierreTurnoData, setCierreTurnoData] = useState([]);
  const [cierreDiaData, setCierreDiaData] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const [traspasoCodEmpleado, setTraspasoCodEmpleado] = useState("");
  const [traspasoCierreTurnoId, setTraspasoCierreTurnoId] = useState("");
  const [traspasoMonto, setTraspasoMonto] = useState("");
  /** mensuales_ef_tc: EF mensual → TC mensual; mensuales_tc_ef: TC mensual → EF mensual */
  const [traspasoSentidoMensuales, setTraspasoSentidoMensuales] = useState("mensuales_ef_tc");
  const [traspasoCargando, setTraspasoCargando] = useState(false);

  const [filtros, setFiltros] = useState({
    centroCostos: "",
    codTerminal: "",
    fechaInicial: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const payloadDesdeFiltros = () => {
    const { centroCostos, codTerminal, fechaInicial } = filtros;
    return {
      codTerminal,
      codPark: centroCostos,
      fechaInicial,
    };
  };

  const authHeaders = () => getFirebaseIdentityHeaders();

  const recargarConsulta = useCallback(async () => {
    const payload = payloadDesdeFiltros();
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (
      !payload.codPark ||
      !payload.codTerminal ||
      !payload.fechaInicial ||
      !fechaRegex.test(payload.fechaInicial)
    ) {
      return { turnos: [], dias: [] };
    }
    const [resTurno, resDia] = await Promise.all([
      axios.post(`/cierre-turno/filtrar`, payload),
      axios.post(`/cierres-dias/buscar`, payload),
    ]);
    const turnos = Array.isArray(resTurno.data) ? resTurno.data : [];
    const dias = Array.isArray(resDia.data) ? resDia.data : [];
    setCierreTurnoData(turnos);
    setCierreDiaData(dias);
    return { turnos, dias };
  }, [filtros.centroCostos, filtros.codTerminal, filtros.fechaInicial]);

  const handleBuscar = async (e) => {
    e.preventDefault();
    const { centroCostos, codTerminal, fechaInicial } = filtros;

    if (!centroCostos || !codTerminal || !fechaInicial) {
      alert(
        "Complete centro de costos, código terminal y fecha (equivalente a sus consultas SQL)."
      );
      return;
    }

    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(fechaInicial)) {
      alert("El formato de fecha debe ser YYYY-MM-DD");
      return;
    }

    setCargando(true);
    setBusquedaRealizada(true);
    try {
      await recargarConsulta();
    } catch (error) {
      console.error("Error al consultar:", error);
      alert(mensajeErrorApi(error) || "Error al consultar cierre de turno y cierre de día.");
      setCierreTurnoData([]);
      setCierreDiaData([]);
    } finally {
      setCargando(false);
    }
  };

  const handleTraspaso = async (e) => {
    e.preventDefault();
    const { centroCostos, codTerminal, fechaInicial } = filtros;

    if (!centroCostos || !codTerminal || !fechaInicial) {
      alert("Primero complete y use los mismos filtros de consulta (centro, terminal y fecha).");
      return;
    }

    const emp = traspasoCodEmpleado.trim();
    if (!emp) {
      alert("Indique el código de empleado.");
      return;
    }

    const montoNum = Number(String(traspasoMonto).replace(",", "."));
    if (Number.isNaN(montoNum) || montoNum <= 0) {
      alert("El monto a traspasar debe ser un número mayor que cero.");
      return;
    }

    setTraspasoCargando(true);
    try {
      const body = {
        codPark: centroCostos,
        codTerminal,
        fechaInicial,
        codEmpleado: emp,
        monto: montoNum,
        sentido: traspasoSentidoMensuales,
      };
      const idStr = String(traspasoCierreTurnoId).trim();
      if (idStr !== "") {
        const idNum = Number(idStr);
        if (!Number.isInteger(idNum) || idNum < 1) {
          alert("Si indica ID de cierre, debe ser un entero mayor que cero (columna ID en la tabla).");
          setTraspasoCargando(false);
          return;
        }
        body.cierreTurnoId = idNum;
      }

      await axios.post(`/cierre-turno/traspaso-mensuales-ef-tc`, body, {
        headers: { ...authHeaders() },
      });

      setTraspasoMonto("");
      const { turnos, dias } = await recargarConsulta();

      let msg =
        traspasoSentidoMensuales === "mensuales_tc_ef"
          ? `Traspaso aplicado: se movieron ${montoNum} de total_mensuales_tc a total_mensuales_ef para el empleado ${emp}.`
          : `Traspaso aplicado: se movieron ${montoNum} de total_mensuales_ef a total_mensuales_tc para el empleado ${emp}.`;

      if (turnos.length > 0 && dias.length > 0) {
        try {
          const nuevasDias = await pasarSumasTurnosACierreDiaApi({
            cierreTurnoData: turnos,
            cierreDiaData: dias,
            codTerminal,
            codPark: centroCostos,
            fechaInicial,
            headers: { ...authHeaders() },
          });
          setCierreDiaData(nuevasDias);
          msg +=
            "\n\nSumas de turnos aplicadas al cierre de día (mismo proceso que «Pasar sumas de turnos a cierre de día» en Trasmitir a Global).";
        } catch (e) {
          console.error("Pasar sumas tras traspaso:", e);
          msg += `\n\nNo se pudieron pasar las sumas al cierre de día: ${mensajeErrorApi(e)}`;
        }
      } else {
        msg +=
          "\n\nNo se pasaron sumas al cierre de día: no hay filas de cierre de día o de turno tras recargar.";
      }

      alert(msg);
    } catch (error) {
      console.error("Traspaso:", error);
      alert(mensajeErrorApi(error));
    } finally {
      setTraspasoCargando(false);
    }
  };

  const handleLimpiar = () => {
    setFiltros({ centroCostos: "", codTerminal: "", fechaInicial: "" });
    setCierreTurnoData([]);
    setCierreDiaData([]);
    setBusquedaRealizada(false);
    setTraspasoCodEmpleado("");
    setTraspasoCierreTurnoId("");
    setTraspasoMonto("");
    setTraspasoSentidoMensuales("mensuales_ef_tc");
  };

  return (
    <div className="cierre-turno-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 className="cierre-turno-title">Ajuste mensuales — consulta</h2>
        <button
          type="button"
          onClick={() => history.push('/Planillas')}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          ← Volver al Home
        </button>
      </div>

      <form
        onSubmit={handleBuscar}
        className="cierre-turno-form"
        style={{ marginBottom: "24px" }}
      >
        <div className="form-row">
          <div className="form-group">
            <label>Centro de costos:</label>
            <input
              type="text"
              name="centroCostos"
              value={filtros.centroCostos}
              onChange={handleChange}
              placeholder="Ej: 244"
            />
          </div>
          <div className="form-group">
            <label>Código terminal:</label>
            <input
              type="text"
              name="codTerminal"
              value={filtros.codTerminal}
              onChange={handleChange}
              placeholder="Ej: K244"
            />
          </div>
          <div className="form-group">
            <label>Fecha (día de fecha_inicial):</label>
            <input
              type="date"
              name="fechaInicial"
              value={filtros.fechaInicial}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-buttons">
          <button type="submit" className="buscar-btn" disabled={cargando}>
            {cargando ? "Consultando..." : "Consultar"}
          </button>
          <button type="button" className="cancelar-btn" onClick={handleLimpiar}>
            Limpiar
          </button>
        </div>
      </form>

      <div className="ajuste-mensuales-traspaso-panel">
        <h3>
          {traspasoSentidoMensuales === "mensuales_tc_ef"
            ? "Traspaso: total_mensuales_tc → total_mensuales_ef (datáfono mensual → efectivo mensual)"
            : "Traspaso: total_mensuales_ef → total_mensuales_tc (efectivo mensual → datáfono mensual)"}
        </h3>
        <p>
          Usa los mismos centro de costos, terminal y fecha de arriba. Elige el sentido con los botones
          de opción. Indica el <strong>cod_empleado</strong> del turno y el <strong>monto</strong>. Si
          ese día hay <strong>varios turnos</strong> para el mismo empleado, indica también el{" "}
          <strong>ID</strong> de la fila en la tabla (si no, el sistema usa el turno con{" "}
          <code>fecha_inicial</code> más reciente, que puede tener la columna de origen en cero). Si no
          hay saldo suficiente en la columna de origen, verás un mensaje claro. Al terminar bien el
          traspaso, si hay cierre de día cargado, se ejecuta automáticamente el mismo proceso que el botón{" "}
          <strong>Pasar sumas de turnos a cierre de día</strong> en <strong>Trasmitir a Global</strong>.
        </p>
        <form onSubmit={handleTraspaso} className="cierre-turno-form" style={{ marginBottom: 0 }}>
          <fieldset
            style={{
              border: "1px solid #b8d4f0",
              borderRadius: "6px",
              padding: "0.75rem 1rem",
              marginBottom: "1rem",
            }}
          >
            <legend style={{ fontWeight: 700, color: "#2c3e50", padding: "0 0.35rem" }}>
              Sentido del traspaso (mensuales)
            </legend>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.35rem" }}>
              <input
                type="radio"
                name="traspasoSentidoMensuales"
                value="mensuales_ef_tc"
                checked={traspasoSentidoMensuales === "mensuales_ef_tc"}
                onChange={() => setTraspasoSentidoMensuales("mensuales_ef_tc")}
              />
              <span>
                Efectivo mensual → datáfono mensual (<code>total_mensuales_ef</code> resta,{" "}
                <code>total_mensuales_tc</code> suma)
              </span>
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <input
                type="radio"
                name="traspasoSentidoMensuales"
                value="mensuales_tc_ef"
                checked={traspasoSentidoMensuales === "mensuales_tc_ef"}
                onChange={() => setTraspasoSentidoMensuales("mensuales_tc_ef")}
              />
              <span>
                Datáfono mensual → efectivo mensual (<code>total_mensuales_tc</code> resta,{" "}
                <code>total_mensuales_ef</code> suma)
              </span>
            </label>
          </fieldset>
          <div className="form-row">
            <div className="form-group">
              <label>Código empleado:</label>
              <input
                type="text"
                value={traspasoCodEmpleado}
                onChange={(ev) => setTraspasoCodEmpleado(ev.target.value)}
                placeholder="Ej: 15810"
              />
            </div>
            <div className="form-group">
              <label>ID cierre (opcional):</label>
              <input
                type="text"
                inputMode="numeric"
                value={traspasoCierreTurnoId}
                onChange={(ev) => setTraspasoCierreTurnoId(ev.target.value)}
                placeholder="Columna ID si hay varios turnos"
              />
            </div>
            <div className="form-group">
              <label>Monto a traspasar:</label>
              <input
                type="number"
                min="1"
                step="1"
                value={traspasoMonto}
                onChange={(ev) => setTraspasoMonto(ev.target.value)}
                placeholder="Valor numérico"
              />
            </div>
          </div>
          <div className="form-buttons">
            <button type="submit" className="buscar-btn" disabled={traspasoCargando || cargando}>
              {traspasoCargando ? "Aplicando..." : "Aplicar traspaso"}
            </button>
          </div>
        </form>
      </div>

      <div className="table-container" style={{ marginBottom: "28px" }}>
        <h3 className="ajuste-mensuales-section-title">Cierre de turno</h3>
        <AjusteMensualesConsultaTurnoTable cierres={cierreTurnoData} />
        {busquedaRealizada && !cargando && cierreTurnoData.length === 0 && (
          <p style={{ color: "#666", marginTop: "8px" }}>
            No hay registros de cierre de turno para los filtros.
          </p>
        )}
      </div>

      <div className="table-container">
        <h3 className="ajuste-mensuales-section-title">Cierre de día</h3>
        <AjusteMensualesConsultaDiaTable cierres={cierreDiaData} />
        {busquedaRealizada && !cargando && cierreDiaData.length === 0 && (
          <p style={{ color: "#666", marginTop: "8px" }}>
            No hay registros de cierre de día para los filtros.
          </p>
        )}
      </div>
    </div>
  );
};

export default AjusteMensualesContainer;
